// extracted by mini-css-extract-plugin
module.exports = {"page":"A_page__SfAZC"};